import React, { useState } from 'react';
import { BitriseArtifactsComponent } from '../BitriseArtifactsComponent/BitriseArtifactsComponent.esm.js';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import CloudDownload from '@material-ui/icons/CloudDownload';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles({
  dialogContent: {
    paddingBottom: 16
  }
});
const BitriseBuildDetailsDialog = ({
  build
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconButton, { "data-testid": "btn", onClick: handleOpen }, /* @__PURE__ */ React.createElement(CloudDownload, null)), /* @__PURE__ */ React.createElement(
    Dialog,
    {
      open,
      onClose: handleClose,
      "aria-labelledby": "alert-dialog-title",
      "aria-describedby": "alert-dialog-description"
    },
    /* @__PURE__ */ React.createElement(DialogTitle, { id: "alert-dialog-title" }, `Download artifacts for build #${build.id}?`, /* @__PURE__ */ React.createElement(IconButton, { "aria-label": "close", edge: "end", onClick: handleClose }, /* @__PURE__ */ React.createElement(CloseIcon, null)), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Chip, { size: "small", label: build.message })),
    /* @__PURE__ */ React.createElement(DialogContent, { className: classes.dialogContent }, /* @__PURE__ */ React.createElement(BitriseArtifactsComponent, { build }))
  ));
};

export { BitriseBuildDetailsDialog };
//# sourceMappingURL=BitriseBuildDetailsDialog.esm.js.map
